const micrositeDefaultState = {
  data: {},
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null
};

const micrositeReducer = (state = micrositeDefaultState, action) => {
  switch(action.type) {
    case 'START_GET_MICROSITE':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_MICROSITE_SUCCESS':
      return {
        ...state,
        data: action.microsite,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'START_CREATE_MICROSITE':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'CREATE_MICROSITE_SUCCESS':
      return {
        ...state,
        data: action.micrositeDetails,
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Microsite has been created',
      };
    case 'START_MICROSITE_UPDATE':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'UPDATE_MICROSITE_SUCCESS':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.micrositeDetails
        },
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Microsite has been updated',
      };
    case 'SHOW_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default micrositeReducer;
